import type {ModelToProps} from '../../Base/types';

import {QuestionModel} from '../Question.model';

export class TextQuestionModel extends QuestionModel {
  constructor(props: TextQuestionModel.Props) {
    super(props);
  }
}

export namespace TextQuestionModel {
  export type Props = ModelToProps<TextQuestionModel>;

  export const isTextQuestionProps = (
    props: QuestionModel.Props,
  ): props is TextQuestionModel.Props => {
    return props.type === 'long_text' || props.type === 'short_text';
  };
}
